import { render } from "./StepThree.vue?vue&type=template&id=8a32f236&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import "./StepThree.vue?vue&type=style&index=0&id=8a32f236&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a32f236"]])

export default __exports__